import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  Divider,
  Image,
  Carousel,
} from "antd";
import { NavLink } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import img from "../../assets/2.jpg";
import img1 from "../../assets/excom-1.png";
import img2 from "../../assets/excom-2.png";
import img3 from "../../assets/excom-3.png";
import img4 from "../../assets/excom-4.png";
import img5 from "../../assets/excom-5.png";

import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const ExecutiveCompensation = () => {
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["executive-compensation-title"]}>
            Executive Compensation
          </Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img} className="responsive-image" alt="Executive" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Unlock the Potential of Strategic Executive Compensation
                </div>
                <Paragraph className={s["main-carusel-description"]}>
                  We specialize in crafting tailored executive compensation
                  strategies that drive business growth and retain top
                  leadership talent.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["executive-compensation-card"]}>
                <Image src={img1} preview={false} />

                <Title level={3}>Customized Compensation Solutions</Title>
                <Paragraph>
                  Every company is unique, and so are your compensation needs.
                  Our approach goes beyond industry norms—we take the time to
                  understand your business strategy, culture, and goals. Whether
                  you need to design performance-based incentives, equity
                  compensation packages, or long-term incentive plans, we ensure
                  your executive pay structure motivates the right behaviors and
                  rewards success.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["executive-compensation-card"]}>
                <Image src={img2} preview={false} />
                <Title level={3}>Data-Driven Benchmarking</Title>
                <Paragraph>
                  Stay ahead of the competition with our comprehensive
                  benchmarking services. We analyze industry data, compare
                  compensation trends, and assess your competitors to ensure
                  your packages are competitive and attractive to top talent.
                  With our insights, your company will stand out in the market
                  for executive leadership.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["executive-compensation-card"]}>
                <Image src={img3} preview={false} />
                <Title level={3}>Aligning Compensation with Performance</Title>
                <Paragraph>
                  A strong compensation plan isn’t just about the salary; it’s
                  about incentivizing the proper outcomes. Our team helps you
                  create performance metrics for business growth, profitability,
                  and long-term success. We align executive compensation with
                  shareholder value, ensuring your company and its leaders
                  achieve lasting success.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["executive-compensation-card"]}>
                <Image src={img4} preview={false} />
                <Title level={3}>Compliance and Transparency</Title>
                <Paragraph>
                  Executive compensation comes with a maze of regulatory
                  requirements. We guide you through compliance with SEC
                  disclosures, tax implications, and other regulations, ensuring
                  that your compensation plans are fully transparent and legally
                  sound.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row justify="center" className={s["executive-compensation-footer"]}>
            <Col>
              <Card className={s["executive-compensation-card"]}>
                <Image src={img5} preview={false} />
                <Title level={3}>Empower Your Leadership</Title>
                <Paragraph>
                  Let us help you craft an executive compensation strategy that
                  attracts, motivates, and retains top-tier leaders who will
                  drive your business forward. Contact us today to learn how we
                  can transform your executive compensation programs into
                  powerful tools for growth.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />

          <Row justify="center" className={s["executive-compensation-footer"]}>
            <Col>
              <Paragraph>
                Our expert consultants partner with your team to design
                compensation plans that align with your company’s goals. All
                while ensuring competitiveness in the marketplace.
              </Paragraph>
              <SendButton
                type="primary"
                size="large"
                className={s["executive-compensation-button"]}
              >
                Get in Touch
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
